import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { ApiNameToProductTranslationKeyMap } from 'pricing-pages-ui/constants/ApiNameToProductTranslationKeyMap';
import { productSelector } from '../../selectors/ProductsSelectors';
import { getCompareApiNamesSelector } from '../../selectors/CompareSelectors';
import { removeFromCompareProducts, updateToCompareProducts } from '../../actions/CompareActions';
import CompareSelectItem from './CompareSelectItem';

const CompareSelect = ({
  apiName
}) => {
  const dispatch = useDispatch();
  const highlightedProducts = useSelector(getCompareApiNamesSelector);
  const getProductCurried = useSelector(state => {
    return ({
      productLine,
      productLevel
    }) => productSelector(state, {
      productLine,
      productLevel
    });
  });

  const createProductLineOptionsSubGroup = ({
    productLine
  }) => currentOrderedPaidProductLevels.map(productLevel => {
    const productOption = getProductCurried({
      productLine,
      productLevel
    });
    return Object.assign({
      text: I18n.text(`compare.productLevel.${productLevel}`),
      value: productOption.apiName,
      disabled: highlightedProducts.includes(productOption.apiName)
    }, apiName === productOption.apiName ? {
      icon: 'success'
    } : {});
  });

  const createProductLineOptionsGroup = () => AllProductLines.map(productLine => {
    return {
      text: I18n.text(`compare.productLine.${productLine}`),
      options: createProductLineOptionsSubGroup({
        productLine
      })
    };
  });

  const handleItemChange = evt => {
    const updatedProduct = evt.target.value;

    if (!updatedProduct) {
      dispatch(removeFromCompareProducts(apiName));
      getUsageTracker().track('compareToolInteraction', {
        action: 'removed product',
        product: apiName,
        productNames: highlightedProducts
      });
    } else {
      dispatch(updateToCompareProducts({
        prevProduct: apiName,
        nextProduct: updatedProduct
      }));
      getUsageTracker().track('compareToolInteraction', {
        action: 'updated product',
        product: apiName,
        updatedProduct,
        productNames: highlightedProducts
      });
    }
  };

  return /*#__PURE__*/_jsx(UISelect, {
    buttonUse: "transparent",
    defaultValue: apiName,
    value: apiName,
    valueRenderer: ({
      value
    }) => {
      return I18n.text(ApiNameToProductTranslationKeyMap[value]);
    },
    itemComponent: CompareSelectItem,
    options: [{
      text: I18n.text('compare.selectAPlan'),
      options: [{
        text: I18n.text('compare.noPlanSelected')
      }]
    }, ...createProductLineOptionsGroup()],
    onChange: handleItemChange,
    searchable: false,
    menuWidth: "auto",
    closeOnTargetLeave: true,
    menuStyle: {
      minHeight: 400
    }
  });
};

export default CompareSelect;